import { render, staticRenderFns } from "./ModuleCourse.vue?vue&type=template&id=58ad2f8b"
import script from "./ModuleCourse.vue?vue&type=script&lang=js"
export * from "./ModuleCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports